import { render, staticRenderFns } from "./ToastNotifications.vue?vue&type=template&id=65bc4aeb&scoped=true&"
import script from "./ToastNotifications.vue?vue&type=script&lang=js&"
export * from "./ToastNotifications.vue?vue&type=script&lang=js&"
import style0 from "./ToastNotifications.vue?vue&type=style&index=0&id=65bc4aeb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bc4aeb",
  null
  
)

export default component.exports